//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum BranchReason {
	Ambiguous = 65,
	UnsupportedBrowser = 66,
	ContinueOnly = 67,
	Disabled = 68,
	Excluded = 69,
	Infrastructure = 73,
	UnsupportedProfile = 76,
	NotPublic = 78,
	OutsidePilot = 79,
	Public = 80,
	DownloadRequired = 82,
	InvalidSource = 83,
	Deadline = 84,
	UntrustedContext = 85
}
